import { FC } from 'react';

import { IconButton } from '@hsp/react-component-library';

import { SecretKeyApprovalProps } from '@c/notifications/components/secret-key-request/types/secret-key-approval.props';

import { s } from '@u/strings';

import { useSecretKeyApprovalConfiguration } from './hooks/configuration.hook';

const SecretKeyApproval: FC<SecretKeyApprovalProps> = ({ secretKey, message }) => {
  const { handleCopy, hasCopied } = useSecretKeyApprovalConfiguration({ secretKey });

  return (
    <div className="d-flex flex-column">
      <div className="mb-3">{message}</div>
      <div className="d-flex justify-content-end">
        <IconButton
          color="primary"
          icon={['fas', hasCopied ? 'check' : 'copy']}
          onClick={handleCopy}>
          {hasCopied ? s(['Site.Copied']) : s(['Site.Copy'])}
        </IconButton>
      </div>
    </div>
  );
};

export default SecretKeyApproval;
